import store from "@/store";

const checkAccess = id =>
  id === 999 ? true : store.getters.wbAccess.includes(id);

export { checkAccess };
